/* src/app/shared/components/missing-verification-form/missing-verification-form.component.scss */
.missingVerificationSection {
  border: 1px solid #C0C0C0;
  border-radius: 5px;
  text-align: left;
  margin-bottom: 10px;
  padding-bottom: 15px;
}
.missingVerificationSection .missingVerificationSection--title {
  display: inline-block;
  position: relative;
  top: -0.5rem;
  left: 1.8rem;
  background: #fff;
  padding: 0 4px;
}
.missingVerificationSection .missingVerificationSection--body {
  text-align: center;
}
.missingVerificationSection .missingVerificationSection--body mat-form-field {
  width: 85%;
}
.missingVerificationSection .missingVerificationSection--body .missingVerificationSection--body__hint {
  color: #a41f35;
}
/*# sourceMappingURL=missing-verification-form.component.css.map */
